<div class="next-offer-detail-box">

  <span class="next-offer-detail-box__icon material-icons">check</span>

  <div class="next-offer-detail-box__text">
    {{label}}<ng-container *ngIf="value">: </ng-container>
    <span *ngIf="value" class="next-offer-detail-box__text__value">
      <ng-container *ngIf="isValueAmount; else notAmount" >
        {{value | separator}} {{'OFFER_SECTION.SHARED.currencyShortcut' | translate}}
    </ng-container>
    <ng-template #notAmount>
        {{value}}
    </ng-template>
    </span>
  </div>
</div>
